import type { GroupBase, StylesConfig } from 'react-select';

import { SearchableSelectType } from '../../../inputs/searchableSelect';
// constants
import defaultStyles from '../../../shared/AampeCreateSelectDropdown/select-style';

export default {
    ...defaultStyles,
    menuPortal: (provided) => ({ ...provided, zIndex: 3000 }),
} as StylesConfig<
    SearchableSelectType,
    boolean,
    GroupBase<SearchableSelectType>
>;
